import { render, staticRenderFns } from "./c-show-phone.vue?vue&type=template&id=2883be1f&scoped=true"
import script from "./c-show-phone.vue?vue&type=script&lang=js"
export * from "./c-show-phone.vue?vue&type=script&lang=js"
import style0 from "./c-show-phone.vue?vue&type=style&index=0&id=2883be1f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2883be1f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/app/node_modules/vuetify/lib/components/VIcon/VIcon.js').default})


/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
